import type { DefaultDashboardDefinition } from './dashboard-definition';

export const subscriptionsDashboard: DefaultDashboardDefinition = {
  id: "subscriptions.main",
  appId: "subscriptions",
  name: "Subscriptions dashboard",
  record: null,
  queryScope: null,
  placements: [
    {
      id: "subscriptions.revenue-trend.default",
      widgetId: "subscriptions.revenue-trend",
      placement: {
        x: 0,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "subscriptions.renewal-trend.default",
      widgetId: "subscriptions.renewal-trend",
      placement: {
        x: 6,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "subscriptions.active.default",
      widgetId: "subscriptions.active",
      placement: {
        x: 0,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "subscriptions.recurring-revenue.default",
      widgetId: "subscriptions.recurring-revenue",
      placement: {
        x: 4,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "subscriptions.renewals-due.default",
      widgetId: "subscriptions.renewals-due",
      placement: {
        x: 8,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "subscriptions.status-list.default",
      widgetId: "subscriptions.status-list",
      placement: {
        x: 0,
        y: 4,
        width: 6,
        height: 4,
      },
    },
    {
      id: "subscriptions.performance-report.default",
      widgetId: "subscriptions.performance-report",
      placement: {
        x: 6,
        y: 4,
        width: 6,
        height: 4,
      },
    },
  ],
};
